
<template>
    <div class="shareBox">
        <slot></slot>
        <!-- 分享弹窗 -->
        <van-dialog
            v-model="shareOtherHint"
            title="如何分享"
            get-container="body"
            :show-cancel-button="false"
            confirm-button-text="关闭"
            confirm-button-color="#333"
            class="shareOtherHint">
            <img src="../../assets/images/common/down_arrows.png" class="down-arrows">
            <div class="text-box">
                <div class="text-title">方式一</div>
                <div class="text">
                    点击“ <img src="../../assets/images/common/icon_1.png" class="icon-1"> ”按钮，选择“分享”，分享给您的朋友~
                </div>
            </div>
            <div class="txt-box">
                <div class="text-title">方式二</div>
                <div class="text copy-text">
                    复制链接分享给您的好友哦~
                </div>
                <span href="#"
                class="size-28  margint-20 col-fcEmphasizeBlue"
                v-clipboard:success="onCopy"
                v-clipboard:copy="copyMessage">点击复制链接</span>
            </div>
        </van-dialog>

        <!-- 微信内分享弹窗 -->
        <div class="shartWxHint" v-if="shareWxHint">
            <div class="shartWx-info">
                请点击右上角“...”，选择分享给您的好友或者分享到朋友圈
            </div>
            <van-overlay :show="shareWxHint" @click="shareWxHint = false" z-index="102"/>
        </div>
    </div>
</template>

<script>
import {
    mapState,
} from 'vuex'
export default {
    name: 'countDownBox',
    props: {
        timestamp: {
            type: Number,
            default: 0
        },
        shareInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    components: {
    },
    data () {
        return {
            shareOtherHint: false, // 微信外
            shareWxHint: false, // 微信
            copyMessage: location.href,
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
    },
    computed: {
        ...mapState({
            iswx: ({
                appInfo
            }) => appInfo.isWeixin
        }),
    },
    methods: {
        onCopy (e) {
            this.$toast('复制成功')
        },
        show (e) {
            /* 优先判断是不是app环境内 */
            if (this.$bridge.isStore()) {
                this.$bridge.onShareSingle({
                    ...this.shareInfo,
                    link: window.location.href
                })
                return
            }
            /* 判断是不是微信还是微信外的浏览器 弹不同的弹窗提示 */
            if (this.iswx) {
                this.shareWxHint = true
            } else {
                this.shareOtherHint = true
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variables'
// .shareBox
</style>
<style src="./resetVant.styl" lang="stylus"></style>
